import { oc } from '@orpc/contract';
import { publishTemplateVersionInputSchema, templateVersionSchema } from '../schemas/templates.schemas.js';
/**
 * Publishes the draft and archives the version it replaces, in one transaction behind an advisory lock
 * keyed on the template (plan §2.3). Published versions are immutable: estimates and stock vehicles keep
 * the version they were computed with (PP AC14).
 */
export const publishTemplateVersionContract = oc
    .route({
    method: 'POST',
    path: '/templates/versions/{versionId}/publish',
    tags: ['Templates'],
    summary: 'Publish the draft template version',
})
    .input(publishTemplateVersionInputSchema)
    .output(templateVersionSchema);
//# sourceMappingURL=publish-template-version.contract.js.map